import {observer} from 'mobx-react';
import {withState} from 'shared/core';
import {Layout, Panel} from 'shared/components';
import {TimeTrackingSubnav} from 'main/containers/time_tracking';
import PolicyDirectory from './PolicyDirectory';
import PayScheduleDirectory from './PayScheduleDirectory';
import EditPayScheduleModal from './EditPayScheduleModal';
import {PoliciesContainerState} from '../state';

const PoliciesContainer = observer(({scope, uiState}) => {
  return (
    <div>
      <TimeTrackingSubnav scope={scope}/>
      <Layout>
        <Panel.Stack loose>
          <PolicyDirectory uiState={uiState}/>
          <PayScheduleDirectory uiState={uiState}/>
        </Panel.Stack>
      </Layout>
      <EditPayScheduleModal uiState={uiState}/>
    </div>
  );
});

export default withState(PoliciesContainer, PoliciesContainerState);
